// import React, { useState, useRef } from "react";
// import backgroundImage from "../../assets/images/profile-dummy.png";
// import Button from "../Buttons/Button";

// const sizeClasses = {
//   xs: "text-[12px] h-24",
//   sm: "text-[12px] h-32",
//   md: "text-[14px] h-40",
//   lg: "text-[16px] h-48",
//   xl: "text-[18px] h-56",
// };

// const FileUploadOne = ({
//   onFileSelect,
//   size = "md",
//   cardHeight = "h-64",
//   cardWidth = "w-48",
// }) => {
//   const [uploadedFiles, setUploadedFiles] = useState([]);
//   const [isDragging, setIsDragging] = useState(false);
//   const fileInputRef = useRef(null);

//   const handleFileChange = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     if (file.type !== "application/pdf") {
//       alert("Only PDF files are supported.");
//       return;
//     }

//     const fileExists = uploadedFiles.some(
//       (existingFile) => existingFile.name === file.name
//     );
//     if (fileExists) {
//       alert("File already uploaded.");
//       return;
//     }

//     const reader = new FileReader();
//     reader.readAsArrayBuffer(file);

//     reader.onload = (e) => {
//       const data = e.target.result;

//       const fileData = {
//         id: Date.now(),
//         name: file.name,
//         pages: 10, // placeholder for page count
//         preview: backgroundImage,
//         type: file.type,
//         data,
//       };

//       // ✅ Update state and notify parent in one place
//       setUploadedFiles((prevFiles) => {
//         const updatedFiles = [...prevFiles, fileData];
//         if (onFileSelect) {
//           onFileSelect(updatedFiles);
//         }
//         return updatedFiles;
//       });
//     };
//   };

//   const handleButtonClick = () => {
//     fileInputRef.current?.click();
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     setIsDragging(true);
//   };

//   const handleDragLeave = (e) => {
//     e.preventDefault();
//     setIsDragging(false);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setIsDragging(false);
//     if (e.dataTransfer.files.length > 0) {
//       const fakeEvent = { target: { files: e.dataTransfer.files } };
//       handleFileChange(fakeEvent);
//     }
//   };

//   return (
//     <div className="w-full h-full">
//       {uploadedFiles.length === 0 ? (
//         <div className="flex items-center justify-center h-full w-full">
//           <div
//             className={`flex flex-col items-center justify-center cursor-pointer min-h-0 max-w-lg ${
//               isDragging ? "bg-primary-50" : "bg-white"
//             }`}
//             onClick={handleButtonClick}
//             onDragOver={handleDragOver}
//             onDragLeave={handleDragLeave}
//             onDrop={handleDrop}
//           >
//             <div
//               className={`flex flex-col items-center justify-center cursor-pointer ${sizeClasses[size]}`}
//             >
//               <span className={`material-symbols-outlined !text-6xl `}>
//                 note_add
//               </span>
//               <p className="my-2">
//                 Drop your Files here, or{" "}
//                 <span className="text-primary-500">browse</span>
//               </p>
//               <p>Supported file type: PDF</p>
//             </div>
//             <input
//               ref={fileInputRef}
//               type="file"
//               onChange={handleFileChange}
//               className="hidden"
//               accept=".pdf"
//             />
//           </div>
//         </div>
//       ) : (
//         <div className="w-full flex flex-wrap gap-4 items-start justify-start">
//           {uploadedFiles.map((file) => (
//             <div
//               key={file.id}
//               className={`flex flex-col justify-end rounded-md shadow overflow-hidden ${cardHeight} ${cardWidth} bg-center bg-cover bg-no-repeat`}
//               style={{ backgroundImage: `url(${backgroundImage})` }}
//             >
//               <div className="bg-white bg-opacity-90 px-3 py-3">
//                 <div className="flex justify-between items-start">
//                   <div className="flex flex-col">
//                     <p className="text-sm font-medium text-gray-800 truncate">
//                       {file.name}
//                     </p>
//                     <p className="text-xs text-gray-500 mt-1">
//                       {file.pages} PAGES
//                     </p>
//                   </div>
//                   <Button
//                     type="icon"
//                     variant="text"
//                     color="black"
//                     icon="more_vert"
//                     className="mb-10"
//                   />
//                 </div>
//               </div>
//             </div>
//           ))}

//           <div
//             className={`flex flex-1 flex-col justify-center overflow-hidden cursor-pointer ${cardHeight} ${cardWidth} rounded-md shadow ${
//               isDragging ? "bg-primary-50" : "bg-white"
//             }`}
//             onClick={handleButtonClick}
//             onDragOver={handleDragOver}
//             onDragLeave={handleDragLeave}
//             onDrop={handleDrop}
//           >
//             <div className=" bg-opacity-90 px-3 py-3 rounded-md">
//               <div className="flex flex-col items-center justify-center">
//                 <span className={`material-symbols-outlined !text-6xl`}>
//                   note_add
//                 </span>
//                 <p className="text-sm my-2 text-center">
//                   Drop your Files here, or{" "}
//                   <span className="text-primary-500">browse</span>
//                 </p>
//                 <p className="text-xs text-gray-500 text-center">
//                   Supported file type: PDF
//                 </p>
//               </div>
//             </div>
//             <input
//               ref={fileInputRef}
//               type="file"
//               onChange={handleFileChange}
//               className="hidden"
//               accept=".pdf"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FileUploadOne;

import React, { useRef, useState } from "react";
import backgroundImage from "../../assets/images/profile-dummy.png";
import Button from "../Buttons/Button";

const sizeClasses = {
  xs: "text-[12px] h-24",
  sm: "text-[12px] h-32",
  md: "text-[14px] h-40",
  lg: "text-[16px] h-48",
  xl: "text-[18px] h-56",
};

const FileUploadOne = ({
  files = [],
  onFileSelect,
  size = "md",
  cardHeight = "h-64",
  cardWidth = "w-48",
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      alert("Only PDF files are supported.");
      return;
    }

    const fileExists = files.some((f) => f.name === file.name);
    if (fileExists) {
      alert("File already uploaded.");
      return;
    }

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = (e) => {
      const data = e.target.result;

      const fileData = {
        id: Date.now(),
        name: file.name,
        pages: 10, // placeholder
        preview: backgroundImage,
        type: file.type,
        data,
      };

      if (onFileSelect) {
        onFileSelect([...files, fileData]);
      }
    };
  };

  const handleButtonClick = () => fileInputRef.current?.click();

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files.length > 0) {
      const fakeEvent = { target: { files: e.dataTransfer.files } };
      handleFileChange(fakeEvent);
    }
  };

  return (
    <div className="w-full h-full">
      {files.length === 0 ? (
        <div className="flex items-center justify-center h-full w-full">
          <div
            className={`flex flex-col items-center justify-center cursor-pointer min-h-0 max-w-lg ${
              isDragging ? "bg-primary-50" : "bg-white"
            }`}
            onClick={handleButtonClick}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <div
              className={`flex flex-col items-center justify-center cursor-pointer ${sizeClasses[size]}`}
            >
              <span className="material-symbols-outlined !text-6xl">
                note_add
              </span>
              <p className="my-2">
                Drop your Files here, or{" "}
                <span className="text-primary-500">browse</span>
              </p>
              <p>Supported file type: PDF</p>
            </div>
            <input
              ref={fileInputRef}
              type="file"
              onChange={handleFileChange}
              className="hidden"
              accept=".pdf"
            />
          </div>
        </div>
      ) : (
        <div className="w-full flex flex-wrap gap-4 items-start justify-start">
          {files.map((file) => (
            <div
              key={file.id}
              className={`flex flex-col justify-end rounded-md shadow overflow-hidden ${cardHeight} ${cardWidth} bg-center bg-cover bg-no-repeat`}
              style={{ backgroundImage: `url(${backgroundImage})` }}
            >
              <div className="bg-white bg-opacity-90 px-3 py-3">
                <div className="flex justify-between items-start">
                  <div className="flex flex-col">
                    <p className="text-sm font-medium text-gray-800 truncate">
                      {file.name}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                      {file.pages} PAGES
                    </p>
                  </div>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    icon="more_vert"
                    className="mb-10"
                  />
                </div>
              </div>
            </div>
          ))}

          <div
            className={`flex flex-1 flex-col justify-center overflow-hidden cursor-pointer ${cardHeight} ${cardWidth} rounded-md shadow ${
              isDragging ? "bg-primary-50" : "bg-white"
            }`}
            onClick={handleButtonClick}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <div className=" bg-opacity-90 px-3 py-3 rounded-md">
              <div className="flex flex-col items-center justify-center">
                <span className="material-symbols-outlined !text-6xl">
                  note_add
                </span>
                <p className="text-sm my-2 text-center">
                  Drop your Files here, or{" "}
                  <span className="text-primary-500">browse</span>
                </p>
                <p className="text-xs text-gray-500 text-center">
                  Supported file type: PDF
                </p>
              </div>
            </div>
            <input
              ref={fileInputRef}
              type="file"
              onChange={handleFileChange}
              className="hidden"
              accept=".pdf"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadOne;
